export default {
  'components.addToCart.success.title': 'Success',
  'components.addToCart.error.title': 'Error',
  'components.addToCart.success.content': 'Proceed to submit!',
  'components.addToCart.error.content': 'Please contact online service!',
  'components.addToCart.success.okBtn': 'Submit',
  'components.addToCart.success.cancelBtn': 'Continue',
  'components.addToCart.error.okBtn': 'Online Service',
};
